import { render, staticRenderFns } from "./note-viewer.vue?vue&type=template&id=91df440c&scoped=true"
import script from "./note-viewer.vue?vue&type=script&lang=js"
export * from "./note-viewer.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "91df440c",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/opt/mse/texting-service/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('91df440c')) {
      api.createRecord('91df440c', component.options)
    } else {
      api.reload('91df440c', component.options)
    }
    module.hot.accept("./note-viewer.vue?vue&type=template&id=91df440c&scoped=true", function () {
      api.rerender('91df440c', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "resources/assets/js/components/send-list/note-viewer.vue"
export default component.exports